import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertasComponent } from '../alertas/alertas.component';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-modifyaccounts',
  templateUrl: './modifyaccounts.component.html',
  styleUrls: ['./modifyaccounts.component.sass']
})
export class ModifyaccountsComponent implements OnInit {
  public tabActive='Manejo de Cuenta';
  public banlist:object;
  public selectBan:string;
  public data:object;
  public offers:Array<any>;
  public addUsersView=false;
  public accountList2;
  public accountId:string='';
  public ssn:string='';
  public markMainAccount:boolean=false;
  public statusLoader:boolean=true;
  public defaultSubcriber:string;
  public expand=[];
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService,public dialog:MatDialog,public AngularFireAnalytics:AngularFireAnalytics){
    this.AngularFireAnalytics.setCurrentScreen("Mis Cuentas");
    this.AngularFireAnalytics.logEvent("Mis Cuentas-Screenview");
  }
  ngOnInit() {
    if(this.global.validateSession()==true){
      if(sessionStorage.getItem("defaultSubscriber")!=null){
        this.defaultSubcriber=atob(sessionStorage.getItem("defaultSubscriber"));
      }
      else{
        this.accountDetails2();
      }
    }
  }
  ngAfterContentInit(){
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    if(this.global.sessionReview()==true){
      this.selectBan='';
      this.accountDetails2();
    }
  }
  accountDetails2(){
    this.offers=[]; 
    if(sessionStorage.getItem("listData")==null){
      this.statusLoader=true;
      this.services.getSubscriberList("", "", sessionStorage.getItem("token"), 1, 3000).subscribe(data => {
        console.log(data);
        if(data.hasError ==false){
          this.loadingScreenService.stopLoading();
          this.accountList2=data.accounts;
          sessionStorage.setItem("listData",btoa(JSON.stringify(data)));
          this.accountDetailsLoad(0);
        }
        else{
          this.global.notif(data.errorDesc);
        }
      });
    }
    else{
      this.statusLoader=false;
      this.accountList2=JSON.parse(atob(sessionStorage.getItem("listData"))).accounts;
      this.accountDetailsLoad(0);
    }
  }
  updateExpand(index){
    this.global.validateSession();
    this.expand[index] = !this.expand[index];
  }
  accountDetails(sw){
    this.offers=[];
    if(this.accountList2==undefined || this.accountList2==null || sw==true){
      this.statusLoader=true;
      this.services.getAcounts(sessionStorage.getItem("token")).subscribe(result =>{
        this.loadingScreenService.stopLoading();
          if(result.hasError ==false){
            sessionStorage.setItem("banlist",btoa(JSON.stringify(result)));
            this.accountList2=result.accounts;
            for(let i=0;this.accountList2.length>i;i++){
              for(let k=0;this.accountList2[i].subscribers.length>k;k++){
                if(this.accountList2[i].defaultAccount==true){
                  if(this.accountList2[i].subscribers[k].defaultSubcriber==true){
                    this.defaultSubcriber=this.accountList2[i].subscribers[k].subscriber;
                  }
                } 
              }
            }
            this.accountDetailsLoad(0);
          }
          else{
            this.global.notif(result.ErrorDesc);
          }
        });
    }
    else{
      this.statusLoader=false;
      this.accountList2=this.accountList2.accounts;
      for(let i=0;this.accountList2.length>i;i++){
        for(let k=0;this.accountList2[i].subscribers.length>k;k++){
          if(this.accountList2[i].defaultAccount==true){
            if(this.accountList2[i].subscribers[k].defaultSubcriber==true){
              this.defaultSubcriber=this.accountList2[i].subscribers[k].subscriber;
            }
          } 
        }
      }
      this.accountDetailsLoad(0);
    }
  }
  accountDetailsLoad(index){
    if ((parseInt(this.accountList2.length) - 1) == index) {
        this.offers.push(JSON.parse(this.offersData(this.accountList2[index].subscribers,this.accountList2[index].account,this.accountList2[index].defaultAccount,this.accountList2[index].accountType,this.accountList2[index].accountSubType,this.accountList2[index].accountName,this.accountList2[index].registerDate)));
        this.loadOffers(this.offers);
    }
    else{
      this.offers.push(JSON.parse(this.offersData(this.accountList2[index].subscribers,this.accountList2[index].account,this.accountList2[index].defaultAccount,this.accountList2[index].accountType,this.accountList2[index].accountSubType,this.accountList2[index].accountName,this.accountList2[index].registerDate)));
      this.accountDetailsLoad((index+1));
    }
  }
  offersData(subscriptores,ban,defaultAccount,accountType,accountSubType,userName,registerDate){
    let typeAccount = this.global.checkTypeAccount(accountType);
    if(defaultAccount==false){
        defaultAccount='N';
    }
    else{
        defaultAccount='Y';
    }
    let ofertas = '{"ban":"'+ban+'","defaultAccount":"'+defaultAccount+'","productType":"'+typeAccount+'","accountType":"'+accountType+'","accountSubType":"'+accountSubType+'","userName":"'+userName+'","registerDate":"'+registerDate+'","offers":[';
    for(var i=0; i < subscriptores.length;i++){
        if (i > 0) {
            ofertas += ',';
        }
        ofertas += '"' +subscriptores[i].subscriber+ '"';
    }
    ofertas += ']}';
    return ofertas;
  }
  loadOffers(offers){
      let ofertas = '{"offers":[';
      for (var i = 0; i < offers.length; i++) {
          if (i > 0) {
              ofertas += ',';
          }
          ofertas += '{"offers":[' + JSON.stringify(offers[i]) + ']}';
      }
      ofertas += ']}';
      this.offers = JSON.parse(ofertas);
    
  }
  unCollapse(){
      this.addUsersView=true;
  }
  collapse(){
        this.addUsersView=false;
  }
  addAccount() {
    if(this.accountId==""){
        this.global.notif("Debe ingresar su número de cuenta.");
    }
    else{
        if(this.ssn==""){
          this.global.notif("Debe ingresar los últimos 4 digitos del seguro social.");
        }
        else{
            var sw=0;
            if(this.accountId.length!=9){
                sw=1;
                this.global.notif("Debe ingresar al menos 9 números.");
            }
            else{
                if(this.ssn.length!=4){
                  sw=1;
                  this.global.notif("Debe ingresar al menos 4 números.");
                }
            }
            if(sw==0){      
                this.loadingScreenService.startLoading();
                var ofertas2 ={};
                this.services.addAccount(this.accountId,this.ssn,this.markMainAccount,sessionStorage.getItem("token")).subscribe(result =>{
                    if(result.hasError ==false){
                        this.services.accountRefresh(sessionStorage.getItem("token")).subscribe(data =>{
                          if(data.hasError ==false){
                            if(this.markMainAccount==true){
                              // OJO AQUI SE DEBE ACTUALIZAR LA CUENTA PRINCIPAL
                          }
                          for(var i=0;i <data.AccountList.length;i++){
                              if(this.accountId==data.AccountList[i].account){
                                  ofertas2 = {"userID":data.AccountList[i].userID, "accountID":data.AccountList[i].accountID, "account": ""+data.AccountList[i].account+"", "accountType": ""+data.AccountList[i].accountType+"", "accountSubType":""+data.AccountList[i].accountSubType+"", "active":data.AccountList[i].active, "productType": ""+data.AccountList[i].productType+"", "subsriberByDefault": ""+data.AccountList[i].subsriberByDefault+"","userName":data.AccountList[i].userName,"registerDate":data.AccountList[i].registerDate};
                                  this.accountDetails(true);
                                  this.accountList2.push(ofertas2);
                                  this.global.notif('Se ha agregado su cuenta con éxito.');
                                  this.accountId='';
                                  this.ssn='';
                              }
                          }
                      }
                      else{
                        this.loadingScreenService.stopLoading();
                        const dialogConfig = new MatDialogConfig();
                        dialogConfig.disableClose = true;
                        dialogConfig.autoFocus = true;
                        dialogConfig.data = {message:result.errorDisplay,messageHtml:true};
                        const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);
                      }
                  });
                }
                else{
                  this.loadingScreenService.stopLoading();
                  const dialogConfig = new MatDialogConfig();
                  dialogConfig.disableClose = true;
                  dialogConfig.autoFocus = true;
                 
                  let n = result.errorDisplay.search(/Hemos detectado que está intentando registrar una cuenta ya existente en nuestro sistema./i);
                  if(n==-1){
                    dialogConfig.data = {message:result.errorDisplay,messageHtml:true};
                    const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);
                  }
                  else{
                    dialogConfig.data = {message:"Hemos detectado que está intentando registrar una cuenta ya existente en nuestro sistema.",messageHtml:true};
                    const dialogRef =this.dialog.open(AlertasComponent, dialogConfig);
                    this.accountId='';
                    this.ssn='';
                  }                  
                }
              });
          }
        }
    }
  }

  deleteAccount(account,index){
    this.loadingScreenService.startLoading();
    this.services.deleteAccount(sessionStorage.getItem("token"),account).subscribe(result =>{
        if(result.hasError ==false){
         this.global.notif("Se ha eliminado su cuenta con éxito.");
         this.accountDetails(true);
        }
        else{
          this.global.notif(result.errorDisplay);
        }
      });
 }
 mainAccountChange(sw,account,productType,accountType,accountSubType,i) {
      let defaultSubcriber='';
      let sw2:boolean=false;
      let sw3:boolean=false;
      for(let k=0;this.accountList2[i].subscribers.length>k;k++){
        if(this.accountList2[i].subscribers[k].subscriber==this.defaultSubcriber){
          sw2=true;
        }
     }
     if(sw==true){
         if(sw2==true){
          defaultSubcriber=this.defaultSubcriber;
         }
         else{
          defaultSubcriber=this.accountList2[i].subscribers[0].subscriber;
         }
         sw3=true;
     }
     else{
        if(sw2==true){
          defaultSubcriber=this.defaultSubcriber;
          sw3=true;
        }
        else{
          sw3=false;
          this.global.notif("Debe selecionar un suscriptor en esta cuenta para realizar su cambio.");
        }
     }
    if(sw3==true){
      this.loadingScreenService.startLoading();
      this.services.setAsDefaultAccount(account,defaultSubcriber,accountType,accountSubType,productType,sessionStorage.getItem("token")).subscribe(result =>{
        this.loadingScreenService.stopLoading();
          if(result.hasError ==false){
            sessionStorage.setItem("mainAccount",account); //revisar estas variables
            sessionStorage.setItem("defaultSubscriber",this.defaultSubcriber); //revisar estas variables
            this.global.notif("Se ha cambiado con éxito.");
            this.accountDetails(true);
          }
          else{
            this.global.notif(result.errorDesc);
          }
        });
    }
  }
}